import { AnchorHTMLAttributes } from "react"
import { Link } from "react-router-dom"

export function MyUserInfoLink({
    children,
    hash,
    ...props
}: AnchorHTMLAttributes<HTMLAnchorElement> & { hash?: string }) {
    const to = ["/my/userinfo", hash].filter(Boolean).join("#")

    return (
        <Link to={to} {...props}>
            {children}
        </Link>
    )
}
